import { SxStyles } from 'types/styles';

export const styles: SxStyles = {
  root: {
    maxWidth: '100vw',
    width: '100%',
    '*': {
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    },
    '*::-webkit-scrollbar': {
      display: 'none',
    },
  },
};
